module.exports = __webpack_public_path__ + "img/188.604b86d3.jpg";